import React, { useEffect, useState } from 'react';
import { Breadcrumb } from 'components';
import { Tabs, Tab, Card } from '@material-ui/core';
import { TabContext, TabPanel } from '@material-ui/lab';
import { useSelector } from 'react-redux';
import useStyles from './styles';
import AspireSyncLogs from './AspireSyncLogs';
import TouchMDSyncLogs from './TouchMDSyncLogs';
import ModMedSyncLogs from './ModMedSyncLogs';
import RPASyncLogs from './RPASyncLogs';


const SyncEventLogPage = () => {
  const classes = useStyles();
  const {profile: {stores = []}} = useSelector((state: IReduxState) => state.user);

  const [{ enabledServices }] = stores;

  const [activeTab, setActiveTab] = useState(null);

  useEffect(() => {
    const activeTabIndex = ['aspire', 'touchmd', 'modmed', 'rpa'].findIndex((service) => enabledServices[service]);
    setActiveTab(activeTabIndex !== -1 ? String(activeTabIndex) : '0');
  }, [enabledServices]);

  return (
    <div className="flex-grow h-full scroll-y pb-25">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'Sync Event Logs' }
          ]}
        />
      </div>
      <div className="mx-10">
        <Card className="m-1">
          <TabContext value={activeTab}>
            <Tabs
              value={activeTab}
              onChange={(e, value) => {
                setActiveTab(value);
              }}
              className={classes.rootTabs}
            >
              {enabledServices.aspire && (
                <Tab
                  className={classes.tabsTitles}
                  label="Aspire"
                  value="0"
                />
              )}
              {enabledServices.touchmd && (
                <Tab
                  className={classes.tabsTitles}
                  label="TouchMD"
                  value="1"
                />
              )}
              {enabledServices.modmed && (
                <Tab
                  className={classes.tabsTitles}
                  label="ModMed"
                  value="2"
                />
              )}
              {enabledServices.rpa && (
                <Tab
                  className={classes.tabsTitles}
                  label="NEXTECH"
                  value="3"
                />
              )}
            </Tabs>
            <TabPanel className="p-0" value="0">
              <AspireSyncLogs />
            </TabPanel>
            <TabPanel className="p-0" value="1">
              <TouchMDSyncLogs />
            </TabPanel>
            <TabPanel className="p-0" value="2">
              <ModMedSyncLogs />
            </TabPanel>
            <TabPanel className="p-0" value="3">
              <RPASyncLogs />
            </TabPanel>
          </TabContext>
        </Card>
      </div>
    </div>
  );
};

export default SyncEventLogPage;
